import React, {useContext, useEffect, useState} from 'react'
import {BaseUrl} from "../../../../contexts/baseUrl/baseUrl";
import localization from "../../../../assets/localization/localization";
import Layout from "../../../../components/sales/layout/layout";
import TableSection from "../../../../components/sales/tableSection/tableSection";
import {Button} from "react-bootstrap";
import ConstantInput from "../../../../components/sales/Input/constantInput/constantInput";
import ModalPop from "../../../../components/sales/modal/modal";
import Images from "../../../../assets/images/imageData";
import {toast} from "react-toastify";

const InvoiceValidationList = ({
                                   getInvoiceList,
                                   invoiceList = [],
                                   ticketClosed = [],
                                   close
                               }) => {

    const [listData, setListData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const {baseUrl} = useContext(BaseUrl);
    const [installmentId, setInstallmentRequestId] = useState(0)
    const [closeModal, setCloseModal] = useState(false)
    const [remark, setRemark] = useState('')

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            getInvoiceList(1)
            setIsLoading(false)
        })()
    }, []);

    const headers = [
        'Installment ID',
        'Site Number',
        'Business Name',
        'Client Name',
        'Generate Date',
        'User Email',
        'Raised Date',
        'Raised By Email',
        'Rejection Remark',
        'status',
        'Action'
    ];


    const handleClose = async () => {
        if (remark === '') {
            toast.warning("Remark is required")
            return false
        }
        let data = {
            installment_request_id: installmentId,
            remark: remark
        }

        setIsLoading(true)
        await close(data)
        setIsLoading(false)
    }

    useEffect(() => {
        if (invoiceList && invoiceList?.data !== undefined && invoiceList?.data?.resultSets !== undefined && invoiceList?.data?.resultSets.length > 0) {
            const tableData = ['installment_request_id', 'site_number', 'business_name', 'client_name', 'invoice_generation_date', 'responsible_user_mail', 'issue_raised_date', 'issue_raised_by_mail', 'client_rejection_remark', 'status'];
            const action = [{name: 'Close Ticket', link: '#'}];
            const data = invoiceList?.data?.resultSets.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        {[key]: element[key]}
                    )),
                    {},

                    element['status'] !== 'CLOSED' ? {Action: action} : {}
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(invoiceList?.data?.total / invoiceList?.data?.per_page));
        }
    }, [invoiceList])

    const onPageChange = async (val) => {
        setIsLoading(true);
        await getInvoiceList(val.selected + 1);
        setIsLoading(false);
    }

    const handleModalHide = () => setCloseModal(false);

    useEffect(() => {
        console.log(invoiceList)
        if (invoiceList?.status !== undefined) {
            if (parseInt(invoiceList?.status) === 400) {
                toast.error(invoiceList?.message)
            }
        }
    }, [invoiceList])

    useEffect(() => {
        setCloseModal(false)
        if (ticketClosed?.status !== undefined) {
            if (parseInt(ticketClosed?.status) === 400) {
                toast.error(ticketClosed?.message)
            } else {
                toast.success(ticketClosed?.message)
            }
        }
    }, [ticketClosed])

    return (
        <Layout
            title={localization.invoice}
            isLoading={isLoading}
            isGoback={true}
        >
            <TableSection
                data={listData}
                isId={false}
                isMngId={false}
                headers={headers}
                pageCount={pageCount}
                onPageChange={onPageChange}
                detailList={invoiceList && invoiceList.data && invoiceList?.data?.resultSets}
                srNo={invoiceList?.data?.from}
                installmentRequestId={setInstallmentRequestId}
                setCloseModal={setCloseModal}
                closeModal={closeModal}
            />

            {closeModal &&
                <ModalPop
                    title={localization.close}
                    show={closeModal}
                    handleModalHide={handleModalHide}
                    keyboard
                    backdrop
                >
                    <ConstantInput
                        label={localization.remark}
                        // regex={Regex.text.test(editClientData.company_name)}
                        errorMsg={localization.requiredCompanyName}
                        type="text"
                        required
                        isStarRequired={true}
                        handleChange={(value) => {
                            setRemark(value)
                        }}
                        placeholder={'What is the RCA for closing this ticket?'}
                    />
                    <Button
                        onClick={() => handleClose()}
                        className="btn btn-transparent"
                    >
                        {localization.continue}{' '}
                        <img src={Images?.ArrowRight} alt=""/>
                    </Button>
                </ModalPop>
            }
        </Layout>
    )
}

export default InvoiceValidationList